module.exports = __webpack_public_path__ + "static/media/HAUX_NUTRICAO_4.d681c4b9.pdf";